import {Button} from '@/components-v2/atoms'
import {AccordionItem} from '@/components-v2/molecules'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMatch, useNavigate} from 'react-router-dom'

export const ComboReviewSection = ({label, content, step}) => {
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))
  const navigate = useNavigate()

  const {setCurrentStep, productCombo} = useProductCombo()

  const handleEditClick = () => {
    if (isComboDetailPage) {
      navigate(ROUTES.CREATE_PRODUCT_COMBINATION, {
        state: {
          productCombo: productCombo,
          step,
        },
      })
    }
    setCurrentStep(step)
  }

  return (
    <AccordionItem
      size="large"
      expanded={true}
      label={<span className="font-medium">{label}</span>}
      rightAccessoryChild={
        <div
          className="ml-4"
          onClick={e => e.stopPropagation()}
          role="presentation"
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.stopPropagation()
            }
          }}
        >
          <Button iconLeading="edit" size="small" variant="tertiary" text="Edit" onClick={handleEditClick} />
        </div>
      }
    >
      {content}
    </AccordionItem>
  )
}
